import { Injectable } from '@angular/core';

@Injectable()
export class PatientUrl {
    public static get GET_PARTY_TYPE(): string { return '/api/Patient/PartyType'; }
    public static get GET_PATIENT_INIT(): string { return '/api/Patient/init'; }
    public static get GET_LIST_PATIENT_ACCOUNT(): string { return '/api/Patient'; }
    public static get GET_LIST_PATIENT_ACCOUNT_COUNT(): string { return '/api/Patient/count'; }
    public static get GET_LIST_PATIENT_BY_EMAIL(): string { return '/api/Patient/getPatients'; }
    public static get GET_PATIENT_ACCOUNT(): string { return '/api/Patient/{id}/detail'; }
    public static get GET_INIT(): string { return '/api/Patient/init'; }
    public static get ADD_PATIENT_ACCOUNT(): string { return '/api/Patient'; }
    public static get EDIT_PATIENT_ACCOUNT(): string { return '/api/Patient/'; }
    public static get REMOVE_PATIENT_ACCOUNT(): string { return '/api/Patient/{id}/delete'; }
    public static get GET_TITLE(): string { return '/api/Patient/GetTitle'; }
    public static get GET_COLLEGE(): string { return '/api/Patient/GetCollege'; }
    public static get GET_HEALTHINSURANCE(): string { return '/api/Patient/GetHealthInsuranceProvider'; }
    public static get GET_PATIENT_PREVIOUS_VACCINE(): string { return '/api/Patient/{id}/recordPreviousVaccine'; }
    public static get DISABLE_PATIENT(): string {return '/api/Patient/{0}/disable'; }

    public static get GET_PATIENT_PREVIOUS_OTHER_VACCINE(): string { return '/api/Patient/{0}/previousOtherVaccine'; }
    public static get GET_PATIENT_ADMINISTED_VACCINE(): string { return '/api/Patient/{0}/administeredVaccine'; }

    public static get GET_CASH_SALE_ACCOUNT(): string { return '/api/Patient/cashSale'; }
    public static get GET_PATIENT_CONSULTATIONS(): string { return '/api/Patient/{0}/consultations'; }
    public static get GET_FULL_AUDIT_TRAIL_HISTORY() { return '/api/Patient/{0}/history/auditTrail'; }
    public static get GET_PATIENT_AUDIT_TRAIL_HISTORY() { return '/api/Patient/{0}/history/auditTrailPatientInfo'; }
    public static get ADD_USER_CENTRE_FOR_PATIENT(): string { return '/api/Patient/{0}/UserCentre'; }

    public static get CHECK_EMAIL_EXISTS(): string { return '/api/Patient/GetEmailAddress'; }
    public static get CHECK_CREATE_MyTMB(): string { return '/api/Patient/{id}/checkCreateMyTMB'; }

    public static get GET_PATIENT_EMAIL(): string { return '/api/Patient/{0}/email'; }
    public static get EMAIL_NEW_UPLOADED_DOCUMENTS(): string { return '/api/Patient/sendEmailNewUploadedDocuments?patientId={0}&consultationId={1}'; }

    public static get EXPORT_TO_CSV(): string { return '/api/Patient/{0}/export?style={1}'; }
    public static get PATIENT_DOWNLOAD_ATTACHMENT(): string { return '/api/Patient/myaccount/download-attachment'; }

    public static get GET_PREVIOUS_MEDICALCONDITION(): string { return '/api/Patient/{0}/previous-medicalCondition?ignorePatientConsulatationId={1}&offset={2}&limit={3}'; }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/patient.url.ts